export function getGlobalStyles(dm) {
  return `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Noto+Sans+KR:wght@400;500;700;900&display=swap');
    :root {
      --accent:${dm ? "#818CF8" : "#6366F1"};
      --accent2:${dm ? "#A78BFA" : "#7C3AED"};
      --gold:${dm ? "#A78BFA" : "#7C3AED"};
      --teal:${dm ? "#2DD4BF" : "#14B8A6"};
      --bg:${dm ? "#0F172A" : "#F6F7FB"};
      --card-bg:${dm ? "rgba(30,41,59,0.85)" : "rgba(255,255,255,0.92)"};
      --card-border:${dm ? "rgba(255,255,255,0.10)" : "rgba(99,102,241,0.14)"};
      --text:${dm ? "#E2E8F0" : "#0F172A"};
      --muted:${dm ? "rgba(226,232,240,0.72)" : "rgba(51,65,85,0.78)"};
      --stamp:${dm ? "#A5B4FC" : "#4338CA"};
      --shadow:${dm ? "rgba(0,0,0,0.45)" : "rgba(15,23,42,0.10)"};
      --surface:${dm ? "rgba(30,41,59,0.55)" : "rgba(255,255,255,0.92)"};
      --border-subtle:${dm ? "rgba(255,255,255,0.08)" : "rgba(99,102,241,0.14)"};
      --nav-muted:${dm ? "rgba(226,232,240,0.45)" : "rgba(51,65,85,0.45)"};
      --nav-bg:${dm ? "rgba(15,23,42,0.88)" : "rgba(255,255,255,0.88)"};
    }
    *{margin:0;padding:0;box-sizing:border-box;}
    html,body{height:auto;overflow-y:auto;overflow-x:hidden;margin:0;padding:0;}
    body{
      background:var(--bg);
      background-image:${dm
        ? "radial-gradient(1200px 500px at 50% -10%, rgba(99,102,241,0.16), transparent), radial-gradient(800px 400px at 90% 20%, rgba(45,212,191,0.06), transparent)"
        : "radial-gradient(1200px 500px at 50% -10%, rgba(99,102,241,0.10), transparent), radial-gradient(800px 400px at 90% 20%, rgba(20,184,166,0.06), transparent)"};
      background-repeat:no-repeat;
      font-family:'Plus Jakarta Sans','Noto Sans KR',-apple-system,sans-serif;
      color:var(--text);
      transition:background 0.4s,color 0.4s;
    }

    /* ── 모바일 앱 셸 ── */
    .app-shell{
      max-width:480px;
      margin:0 auto;
      padding:0 16px calc(84px + env(safe-area-inset-bottom, 0px));
      min-height:100vh;
    }
    .app-header{
      position:sticky; top:0; z-index:50;
      display:flex; align-items:center; justify-content:space-between;
      min-height:54px;
      margin:0 -16px 4px;
      padding:calc(8px + env(safe-area-inset-top, 0px)) 16px 8px;
      background:${dm ? "rgba(15,23,42,0.82)" : "rgba(246,247,251,0.85)"};
      backdrop-filter:blur(14px);
      -webkit-backdrop-filter:blur(14px);
      border-bottom:1px solid ${dm ? "rgba(255,255,255,0.06)" : "rgba(99,102,241,0.08)"};
    }
    .bottom-nav{
      position:fixed; left:0; right:0; bottom:0; z-index:60;
      background:var(--nav-bg);
      backdrop-filter:blur(18px);
      -webkit-backdrop-filter:blur(18px);
      border-top:1px solid ${dm ? "rgba(255,255,255,0.08)" : "rgba(99,102,241,0.12)"};
      padding-bottom:env(safe-area-inset-bottom, 0px);
      box-shadow:0 -4px 24px ${dm ? "rgba(0,0,0,0.35)" : "rgba(15,23,42,0.06)"};
    }
    .bottom-nav-inner{
      max-width:480px; margin:0 auto;
      display:flex; align-items:stretch;
    }
    .bottom-nav-tab{
      flex:1; min-height:60px;
      display:flex; flex-direction:column; align-items:center; justify-content:center;
      background:none; border:none; cursor:pointer;
      font-family:inherit;
      transition:color 0.25s, transform 0.15s;
      -webkit-tap-highlight-color:transparent;
      padding:4px 0 7px;
    }
    .bottom-nav-tab:active{ transform:scale(0.93); }

    ::-webkit-scrollbar{width:5px;}
    ::-webkit-scrollbar-track{background:${dm ? 'rgba(129,140,248,0.04)' : 'rgba(99,102,241,0.06)'}}
    ::-webkit-scrollbar-thumb{background:${dm ? 'rgba(129,140,248,0.45)' : 'rgba(99,102,241,0.38)'};border-radius:3px;}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
    @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
    @keyframes float{0%,100%{transform:translateY(0) rotate(-1deg)}50%{transform:translateY(-12px) rotate(1deg)}}
    @keyframes drift{0%{transform:translateX(-60px) translateY(10px) rotate(12deg);opacity:0}
      20%{opacity:0.5}80%{opacity:0.4}100%{transform:translateX(110vw) translateY(-40px) rotate(12deg);opacity:0}}
    @keyframes shimmer{0%,100%{opacity:0.1}50%{opacity:0.4}}
    @keyframes stampIn{0%{transform:scale(1.3) rotate(-6deg);opacity:0}100%{transform:scale(1) rotate(0deg);opacity:1}}
    @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,102,241,0.4)}50%{box-shadow:0 0 0 10px rgba(99,102,241,0)}}
    @keyframes glowPulse{0%,100%{opacity:0.6}50%{opacity:1}}
    @keyframes lineGrow{from{width:0}to{width:100%}}
    .glass-card{
      background:var(--card-bg);
      border:1px solid var(--card-border);
      backdrop-filter:blur(20px);
      -webkit-backdrop-filter:blur(20px);
      border-radius:24px;
      padding:22px;
      position:relative;
      overflow:hidden;
      box-shadow:0 1px 3px var(--shadow), 0 12px 32px var(--shadow), 0 1px 0 rgba(255,255,255,0.06) inset;
      transition:all 0.4s cubic-bezier(0.4,0,0.2,1);
    }
    .animate-in{animation:fadeUp 0.5s cubic-bezier(0.16,1,0.3,1) forwards}

    /* ── 입체 버튼: 누르면 아래 엣지가 사라지며 그만큼 내려앉는다 ──
       색/그림자는 styles/buttonStyles.js가 인라인으로 넣고,
       누름 상태만 여기서 처리한다(터치·마우스 공통). */
    .btn3d{
      position:relative;
      font-family:inherit;
      cursor:pointer;
      -webkit-tap-highlight-color:transparent;
      transition:transform .12s cubic-bezier(0.4,0,0.2,1),
                 box-shadow .12s cubic-bezier(0.4,0,0.2,1),
                 filter .2s ease;
    }
    .btn3d:active:not(:disabled){
      transform:translateY(3px);
      box-shadow:var(--btn3d-active) !important;
    }
    .btn3d:disabled{ cursor:not-allowed; }
    @media (hover:hover){
      .btn3d:hover:not(:disabled){ filter:brightness(1.04); }
    }
    .btn3d:focus-visible{
      outline:2px solid ${dm ? "#A5B4FC" : "#4F46E5"};
      outline-offset:2px;
    }
    .daily-card-widget:active,
    .itinerary-spot-line:active{
      transform:translateY(2px) scale(0.99);
    }
    .daily-card-widget:focus-visible,
    .itinerary-spot-line:focus-visible{
      outline:2px solid ${dm ? "#A5B4FC" : "#4F46E5"};
      outline-offset:2px;
    }
    @media (hover:hover){
      .itinerary-spot-line:hover{ background:rgba(99,102,241,0.10); }
    }
    input::placeholder{color:${dm ? 'rgba(226,232,240,0.55)' : 'rgba(51,65,85,0.5)'};font-weight:400}
    input,select{color:var(--text)!important;} input:-webkit-autofill{-webkit-text-fill-color:var(--text)!important;-webkit-box-shadow:0 0 0 1000px ${dm ? 'rgba(15,23,42,0.98)' : 'rgba(255,255,255,0.98)'} inset!important;}
    select option{background:${dm ? '#1E293B' : '#F8FAFC'}!important;color:${dm ? '#E2E8F0' : '#0F172A'}!important;}
    .stamp-border{border:1.5px dashed ${dm ? 'rgba(129,140,248,0.3)' : 'rgba(99,102,241,0.3)'};border-radius:4px;}
    .serif{font-family:inherit!important;}
    .tag-pill{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:100px;font-size:10px;font-weight:700;letter-spacing:0.06em;background:${dm ? 'rgba(129,140,248,0.12)' : 'rgba(99,102,241,0.1)'};border:1px solid ${dm ? 'rgba(129,140,248,0.25)' : 'rgba(99,102,241,0.22)'};color:${dm ? 'rgba(165,180,252,0.9)' : 'rgba(67,56,202,0.9)'};}
    .divider-line{height:1px;background:${dm ? 'linear-gradient(90deg,transparent,rgba(129,140,248,0.2),rgba(45,212,191,0.15),transparent)' : 'linear-gradient(90deg,transparent,rgba(99,102,241,0.18),transparent)'};margin:16px 0;}
  `;
}
